import {IDataModifiers, IModifiable} from "./GenericData";
import {IArmor} from "./IArmorData";
import {IMinionData} from "./IMinionData";
import {IFatelineData} from "./IFatelineData";
import {IDowntimePlayerData} from "./IDowntime";
import {ICharacterRacialData} from "./IRacialData";

export interface IAttributeBars {
    health: IAttributeBar,
    stamina: IAttributeBar,
    tether: IAttributeBar
    orders: IAttributeBar,
    technik: IAttributeBar
}

export interface ICharacterStats {
    might: IModifiable,
    agility: IModifiable,
    skill: IModifiable,
    awareness: IModifiable,
    vitality: IModifiable,
    knowledge: IModifiable,
    mind: IModifiable,
    presence: IModifiable,
    authority: IModifiable,
    endurance: IModifiable
}

export interface IPreparedCard {
    cardId: string,
    additionalData?: number
}

export interface IPreparedSource {
    sourceId: string,
    attunementLevel: number
}

export interface ISettingsData {
    dieColorId: string,
    showAttributeDescriptions: boolean
}

export interface IMiscUnlockData {
    categoryId: string,
    unlockIds: Array<string>
}

export interface ICharacterBaseData {
    characterName: string,
    characterLevel: number,
    isMainCharacter: boolean,
    classList: Array<string>,
    affinities: IAffinities
    fatelineIds: Array<string>,
    fatelineUnlockIds: Array<string>,
    miscUnlockTags: Array<IMiscUnlockData>,
    classes: Array<IClassData_deprecated>,
    attributeBars: IAttributeBars,
    downtimeData: Array<IDowntimePlayerData>,
    fateline: IFatelineData|undefined,
    currentActionPoints: number,
    characterStats: ICharacterStats,
    race: ICharacterRacialData|undefined,
    specialId: string,
    movement: {
        canClimb?: boolean,
        canFly?: boolean
        canSwim?: boolean
    },
    bonuses?: {
        staminaRefresh?: number,
        tetherRefresh?: number,
        maxHealth?: number,
        maxStamina?: number,
        maxTether?: number,
        expertiseDice?: number,
        hitBonus?: number,
        critBonus?: number,
    },
    preparedCards: Array<IPreparedCard>,
    preparedCommanderCards: Array<string>,
    createdSpells: Array<ICalculatedSpell>,
    createdWeapons: Array<ICalculatedWeapon>,
    createdHacks: Array<ICalculatedHack>,
    currentSpell: ICalculatedSpell | null,
    currentWeapon: ICalculatedWeapon | null,
    currentHack: ICalculatedHack | null,
    currentOffhandWeapon: ICalculatedWeapon | null,
    counterWeapon: ICalculatedWeapon | null,
    currentArmor: IEnchantmentData | null,
    currentShield: IEnchantmentData | null,
    knownConsumables: Array<IConsumablePlayerData>,
    knownArmor: Array<IEnchantmentData>,
    knownBaseSpells: Array<string>,
    knownWeapons: Array<IEnchantmentData>,
    knownSources: Array<IPreparedSource>,
    temporarySources: Array<IPreparedSource>,
    knownDatachips: Array<string>,
    knownPackages: Array<string>,
    knownGadgets: Array<IGadgetCharacterData>,
    skillPoints: ISkillPointObject,
    minionsOwned: Array<IMinionOwnedData>,
    settings: ISettingsData,
    characterImageKey: string,
    campaignIds: Array<string>,
    isDead: boolean,
    creatorName: string,
    currencyValues: Array<ICurrencyData>,
    developmentIds: Array<string>,
    __times_accessed: number,
    _id: string
}

export interface IGadgetCharacterData {
    gadgetId: string,
    isGadgetActive: boolean
}

export interface ICurrencyData {
    _id?: string,
    currencyType: string,
    currencyStore: string,
    currencyAmount: number
}

export interface IMinionOwnedData {
    minionId: string,
    isEquipped: boolean,
    equippedAs: string
}

export interface IEnchantmentData {
    baseId: string,
    enchantmentLevel: number,
    improvements?: number,
    efficientUse?: boolean
}

export interface IConsumablePlayerData {
    consumableId: string,
    amount: number,
    prepared: number
}

export interface ISkillPointObject {
    athletics: number,
    handling: number,
    stealth: number,
    deduction: number,
    identify: number,
    science: number,
    technology: number,
    biology: number,
    metaphysics: number,
    spellcraft: number,
    survival: number,
    perception: number,
    streetwise: number,
    discovery: number,
    diplomacy: number,
    hostility: number,
    guile: number,
    lore: number,
    occult: number,
    society: number
}

export const ESkill = ["athletics", "handling", "stealth", "deduction", "identify", "science", "technology", "biology", "metaphysics", "spellcraft", "survival", "perception" ,"streetwise", "discovery", "diplomacy", "hostility", "guile", "lore", "occult", "society"]

export interface IAttributeBar {
    current: number,
    scaling: IModifiable
}

export interface IClassData_deprecated {
    className: string,
    affinities: IAffinities,
    classExpertises: Array<string>,
    classTier: number,
    isPromoted: boolean
}

export interface IClassData {
    className: string,
    classExpertises: Array<string>,
    classTier: number,
    isPromoted: boolean
}

export interface IAffinities {
    finesse: number,
    infantry: number,
    guardian: number,
    evocation: number,
    creation: number,
    alteration: number,
    command: number,
    supply: number,
    mentorship: number,
    swift: number,
    riding: number,
    adaptation: number,
    rune: number,
    sourcecraft: number,
    research: number,
    animancy: number,
    conjuration: number,
    orchestration: number,
    proxy: number,
    firewall: number,
    virus: number,
    transduction: number,
    machinery: number,
    crafting: number
}



export interface IAffinitiesAndPath {
    affinities: IAffinities,
    path: IPathKeys
}

export interface IAffinitiesArray<T> {
    finesse: Array<T>,
    infantry: Array<T>,
    guardian: Array<T>,
    evocation: Array<T>,
    creation: Array<T>,
    alteration: Array<T>,
    command: Array<T>,
    supply: Array<T>,
    mentorship: Array<T>,
    swift: Array<T>,
    riding: Array<T>,
    adaptation: Array<T>,
    rune: Array<T>,
    sourcecraft: Array<T>,
    research: Array<T>,
    animancy: Array<T>,
    conjuration: Array<T>,
    orchestration: Array<T>,
    proxy: Array<T>,
    firewall: Array<T>,
    virus: Array<T>,
    transduction: Array<T>,
    machinery: Array<T>,
    crafting: Array<T>
}

export interface IPathKeys {
    warrior: number,
    arcanist: number,
    captain: number,
    navigator: number,
    scholar: number,
    summoner: number,
    cipher: number,
    engineer: number
}

export interface IPathArray<T> {
    warrior: Array<T>,
    arcanist: Array<T>,
    captain: Array<T>,
    navigator: Array<T>,
    scholar: Array<T>,
    summoner: Array<T>,
    cipher: Array<T>,
    engineer: Array<T>
}

export interface IPathKeysPlusAny {
    warrior: number,
    arcanist: number,
    captain: number,
    navigator: number,
    scholar: number,
    summoner: number,
    cipher: number,
    engineer: number,
    any: number
}

export interface ICalculatedSpell {
    customName?: string,
    spellBaseId: string,
    spellTargetId: string,
    spellSkillsIds: Array<string>
}


export interface ICalculatedArmor {
    baseId: string,
    enchantmentLevel: 0
}

export interface ICalculatedWeapon {
    customName?: string,
    weaponBaseData: IEnchantmentData,
    weaponCardsIds: Array<string>
}

export interface ICalculatedHack {
    customName?: string,
    hackIOId: string,
    hackFunctionId: string,
    hackProtocolId: string,
    hackCardsIds: Array<string>
}

export type UStance = "block" | "evade" | "exposed"